import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { NonOwnerPersonnel } from 'app/models/dto/non-owner-personnel.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';


@Injectable({
    providedIn: 'root'
})

export class NonOwnerPersonnelService {

    baseUrl = environment.API_URL;

    constructor(private http:  ApiHttpClient) {
      this.baseUrl = environment.API_URL;
    }

    create(newNonOwnerPersonnel: NonOwnerPersonnel): Observable<NonOwnerPersonnel> {
        return this.http.post<NonOwnerPersonnel>(`${this.baseUrl}/non-owner-personnel`, newNonOwnerPersonnel);
    }

    getNonOwnerPersonnelForBorrower(borrowerId: number): Observable<NonOwnerPersonnel[]> {
        return this.http.get<NonOwnerPersonnel[]>(`${this.baseUrl}/borrower/${borrowerId}/non-owner-personnel`);
    }

    update(nonOwnerPersonnel: NonOwnerPersonnel, ): Observable<NonOwnerPersonnel> {
        return this.http.put<NonOwnerPersonnel>(`${this.baseUrl}/non-owner-personnel`, nonOwnerPersonnel);
    }

    delete(nonOwnerPersonnelId: number): Observable<any> {
        return this.http.delete<NonOwnerPersonnel>(`${this.baseUrl}/non-owner-personnel/${nonOwnerPersonnelId}`);
    }
}
